import { createApiAction } from 'src/api';

export const SEND_ACCOUNT_INVITE_START = 'account/send_account_invite_start';
export const SEND_ACCOUNT_INVITE_SUCCESS =
  'account/send_account_invite_success';
export const SEND_ACCOUNT_INVITE_FAILURE =
  'account/send_account_invite_failure';

export const FETCH_ACCOUNT_START = 'account/fetch_account_start';
export const FETCH_ACCOUNT_SUCCESS = 'account/fetch_account_success';
export const FETCH_ACCOUNT_FAILURE = 'account/fetch_account_failure';

export const UPDATE_ACCOUNT_START = 'account/update_account_start';
export const UPDATE_ACCOUNT_SUCCESS = 'account/update_account_success';
export const UPDATE_ACCOUNT_FAILURE = 'account/update_account_failure';

export const DELETE_ACCOUNT_START = 'account/delete_account_start';
export const DELETE_ACCOUNT_SUCCESS = 'account/delete_account_success';
export const DELETE_ACCOUNT_FAILURE = 'account/delete_account_failure';

export const UPDATE_ACCOUNT_FIS_START = 'account/update_account_fis_start';
export const UPDATE_ACCOUNT_FIS_SUCCESS = 'account/update_account_fis_success';
export const UPDATE_ACCOUNT_FIS_FAILURE = 'account/update_account_fis_failure';

export const SIGN_CONSENT_START = 'account/sign_consent_start';
export const SIGN_CONSENT_SUCCESS = 'account/sign_consent_success';
export const SIGN_CONSENT_FAILURE = 'account/sign_consent_failure';

export const SIGN_SUBMISSION_START = 'account/sign_submission_start';
export const SIGN_SUBMISSION_SUCCESS = 'account/sign_submission_success';
export const SIGN_SUBMISSION_FAILURE = 'account/sign_submission_failure';

export const ADD_ACCOUNT_CONSENT_TYPE_START =
  'account/add_account_consent_type_start';
export const ADD_ACCOUNT_CONSENT_TYPE_SUCCESS =
  'account/add_account_consent_type_success';
export const ADD_ACCOUNT_CONSENT_TYPE_FAILURE =
  'account/add_account_consent_type_failure';

export const sendAccountInvite = ({
  financialInstitutionId,
  businessName,
  ownerEmail,
  ownerFirstName,
  ownerLastName,
  ownerMobilePhone,
  bgCheckNeeded,
  bankingService,
  paymentService,
  lendingService,
  insuranceService,
  sendEmail,
  hasBusinessPage,
  hasLocationsPage,
  hasPeoplePage,
  hasVendorsPage,
  hasProductsPage,
  hasPaymentsPage,
  hasDocumentsPage,
  hasConsentsPage,
  hasLoansPage,
  hasObligationsPage,
  ndaNeeded,
  servicesOffered,
  chargeBackFee,
  salesTrxFee,
  monthlyMinimumFee,
  pciMonthlyProgramFee,
  retrievalFee,
  returnFee,
  batchCloseFee,
  terminalIdFee,
  monthlyStatementFee,
  onlinePortalFee,
  pciNonComplianceFee,
  achRejectFee,
  pricingFormat,
  processingType,
  pinBasedDebitRate,
}) =>
  createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/accounts/invitation/`,
      method: 'POST',
      body: {
        invitation_business_name: businessName,
        invitation_owner_email: ownerEmail,
        invitation_owner_first_name: ownerFirstName,
        invitation_owner_last_name: ownerLastName,
        invitation_owner_mobile_number: ownerMobilePhone,
        invitation_bg_check_needed: bgCheckNeeded || false,
        invitation_for_banking: bankingService || false,
        invitation_for_payments: paymentService || false,
        invitation_for_lending: lendingService || false,
        invitation_for_insurance: insuranceService || false,
        send_email: sendEmail || false,
        invitation_has_business_page: hasBusinessPage || false,
        invitation_has_locations_page: hasLocationsPage || false,
        invitation_has_people_page: hasPeoplePage || false,
        invitation_has_vendors_page: hasVendorsPage || false,
        invitation_has_products_page: hasProductsPage || false,
        invitation_has_payments_page: hasPaymentsPage || false,
        invitation_has_documents_page: hasDocumentsPage || false,
        invitation_has_consents_page: hasConsentsPage || false,
        invitation_has_loans_page: hasLoansPage || false,
        invitation_has_obligations_page: hasObligationsPage || false,
        invitation_nda_needed: ndaNeeded || false,
        invitation_services_offered: servicesOffered || [],
        // new payment fields
        account_pricing_format: pricingFormat,
        account_processing_type: processingType,
        account_pin_based_debit_rate: pinBasedDebitRate,
        account_chargeback_fee: chargeBackFee,
        account_sales_trx_fee: salesTrxFee,
        account_monthly_minimum_fee: monthlyMinimumFee,
        account_pci_monthly_program_fee: pciMonthlyProgramFee,
        account_retrieval_fee: retrievalFee,
        account_return_fee: returnFee,
        account_batch_close_fee: batchCloseFee,
        account_terminal_id_fee: terminalIdFee,
        account_monthly_statement_fee: monthlyStatementFee,
        account_online_portal_fee: onlinePortalFee,
        account_pci_non_compliance_fee: pciNonComplianceFee,
        account_ach_reject_fee: achRejectFee,
      },
    },
    [
      SEND_ACCOUNT_INVITE_START,
      SEND_ACCOUNT_INVITE_SUCCESS,
      SEND_ACCOUNT_INVITE_FAILURE,
    ]
  );

export const fetchAccount = accountId =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/`,
    },
    [FETCH_ACCOUNT_START, FETCH_ACCOUNT_SUCCESS, FETCH_ACCOUNT_FAILURE]
  );

export const updateAccount = ({
  accountId,
  businessName,
  businessSince,
  industries,
  taxId,
  naics,
  businessEmail,
  customerServiceEmail,
  customerServicePhone,
  primaryPhone,
  otherPhone,
  website,
  facebook,
  linkedin,
  twitter,
  instagram,
  briefDescription,
  entityType,
  incorporationState,
  currentOwnership,
  entityStartDate,
  varSheetMid,
  varSheetIssuedDate,
  reportingMid,
  midActiveToggle,
  accountStatus,
  acceptsTips,
  insuranceGroupNames,
}) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/`,
      method: 'PUT',
      body: {
        account_business_name: businessName,
        account_business_since: businessSince,
        account_industries: industries,
        account_tax_id: taxId != null ? taxId.replace(/[^0-9]/g, '') : null,
        account_naics: naics !== '' ? naics : null,
        account_business_email: businessEmail,
        account_customer_service_email: customerServiceEmail,
        account_customer_service_phone: customerServicePhone,
        account_primary_phone: primaryPhone,
        account_other_phone: otherPhone,
        account_website: website,
        account_facebook: facebook,
        account_linkedin: linkedin,
        account_twitter: twitter,
        account_instagram: instagram,
        account_brief_description: briefDescription,
        account_entity_type: entityType,
        account_incorporation_state: incorporationState,
        account_current_ownership: currentOwnership,
        account_entity_start_date: entityStartDate,
        account_varsheet_mid: varSheetMid,
        account_varsheet: varSheetIssuedDate,
        account_mid: reportingMid,
        account_mid_active: midActiveToggle,
        account_status: accountStatus,
        account_accepts_tips: acceptsTips,
        account_insurance_group_names: insuranceGroupNames,
      },
    },
    [UPDATE_ACCOUNT_START, UPDATE_ACCOUNT_SUCCESS, UPDATE_ACCOUNT_FAILURE]
  );

export const updateAccountFI = ({
  accountId,
  financialInstitutionId,
  currentCustomer,
  memberId,
  services,
  accountStatus,
}) => {
  const body = {
    financial_institution_account_current_customer: currentCustomer,
    financial_institution_account_member_id: memberId,
    financial_institution_account_services_channels: services,
    financial_institution_account_status: accountStatus,
  };

  return createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/fis/${financialInstitutionId}/`,
      method: 'PUT',
      body,
    },
    [
      UPDATE_ACCOUNT_FIS_START,
      UPDATE_ACCOUNT_FIS_SUCCESS,
      UPDATE_ACCOUNT_FIS_FAILURE,
    ]
  );
};

export const deleteAccount = (financialInstitutionId, accountId) =>
  createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/accounts/${accountId}/`,
      method: 'DELETE',
    },
    [DELETE_ACCOUNT_START, DELETE_ACCOUNT_SUCCESS, DELETE_ACCOUNT_FAILURE]
  );

export const addAccountConsentType = ({ accountId, consentTypeId }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/consent_types/${consentTypeId}/`,
      method: 'POST',
      body: {},
    },
    [
      ADD_ACCOUNT_CONSENT_TYPE_START,
      ADD_ACCOUNT_CONSENT_TYPE_SUCCESS,
      ADD_ACCOUNT_CONSENT_TYPE_FAILURE,
    ]
  );

export const signConsent = ({ accountId, consentTypeId, initials }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/consent_types/${consentTypeId}/consents/`,
      method: 'POST',
      body: {
        initials,
      },
    },
    [SIGN_CONSENT_START, SIGN_CONSENT_SUCCESS, SIGN_CONSENT_FAILURE]
  );

export const signSubmission = ({
  financialInstitutionId,
  accountId,
  initials,
  message,
  explanationBusiness,
  explanationLocations,
  explanationObligations,
  explanationLoans,
  explanationPeople,
  explanationVendors,
  explanationProducts,
  explanationDocuments,
  explanationConsents,
}) =>
  createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/accounts/${accountId}/submission/`,
      method: 'POST',
      body: {
        initials,
        message,
        account_explanation_business: explanationBusiness || '',
        account_explanation_locations: explanationLocations || '',
        account_explanation_loans: explanationLoans || '',
        account_explanation_obligations: explanationObligations || '',
        account_explanation_people: explanationPeople || '',
        account_explanation_vendors: explanationVendors || '',
        account_explanation_products: explanationProducts || '',
        account_explanation_documents: explanationDocuments || '',
        account_explanation_consents: explanationConsents || '',
      },
    },
    [SIGN_SUBMISSION_START, SIGN_SUBMISSION_SUCCESS, SIGN_SUBMISSION_FAILURE]
  );
